import React, { useEffect } from 'react'
import { Menu } from 'antd'
import { Link } from 'react-router-dom'

import UserProfile from './UserProfile'

import { useSelector } from 'react-redux'
import { CheckOutlined, HomeFilled, HourglassOutlined } from '@ant-design/icons'
import {
  FaUsers,
  FaBuilding,
  FaBriefcase,
  FaBook,
  FaBookReader,
  FaCheckDouble,
  FaClock,
  FaClipboardCheck,
  FaVoteYea,
  FaUsersCog,
  FaUserPlus,
  FaHeadset,
} from 'react-icons/fa'
import { MdDashboard, MdReport } from 'react-icons/md'
import Helpers from '../../util/Helpers'
import { MAIN_MENU } from '../../constants/ServerUrl'

const SubMenu = Menu.SubMenu
const MenuItemGroup = Menu.ItemGroup
const SidebarContent = ({
  sidebarCollapsed,
  setSidebarCollapsed,
  onMenuClick,
}) => {
  let { navStyle, themeType } = useSelector(({ settings }) => settings)
  let { pathname } = useSelector(({ common }) => common)
  const { authorizations } = useSelector(({ auth }) => auth)

  let selectedKeys = pathname.substr(1)
  let defaultOpenKeys = selectedKeys.split('/')[1]
  // const defaultOpenKeys = selectedKeys.split('/')[1];

  return (
    <>
      <div className='flex items-center justify-center p-2 relative'>
        <UserProfile />
        {/*<AppsNavigation/>*/}
      </div>

      <Menu
        className='bg-blue text-white text-center text-base font-medium mb-5 main-menu'
        mode='inline'
        defaultOpenKeys={[defaultOpenKeys]}
        selectedKeys={[selectedKeys]}
        onClick={onMenuClick}
        triggerSubMenuAction='click'
      >
        <MenuItemGroup key='dashboard' className='gx-menu-group'>
          <Menu.Item key='home' className='sider-menu-item'>
            <Link to='/home' className='flex'>
              <div className='text-xl md:text-2xl my-auto'>
                <MdDashboard />
              </div>
              <span className='mx-4 py-1'>Dashboard</span>
            </Link>
          </Menu.Item>
        </MenuItemGroup>

        <MenuItemGroup key='help-desk' className='gx-menu-group'>
          <Menu.Item key='company/helpdesk' className='sider-menu-item'>
            <Link to='/company/helpdesk' className='flex'>
              <div className='text-xl md:text-2xl my-auto'>
                <FaHeadset />
              </div>
              <span className='mx-4 py-1'>Help Desk</span>
            </Link>
          </Menu.Item>
        </MenuItemGroup>

        {/* <MenuItemGroup key='polls' className='gx-menu-group'>
          {Helpers.authorizeMe(authorizations[7], 'view', 29) && (
            <SubMenu
              key='polls'
              title={
                <div className='flex my-3 text-white items-center'>
                  <div className='text-xl md:text-2xl'>
                    <FaVoteYea />
                  </div>
                  <div className='px-4 -my-3'>Voting</div>
                </div>
              }
            >
              <Menu.Item key='voting/polls'>
                <Link to='/voting/polls'>
                  <span className='pl-3 text-gray-200 text-sm'>Polls</span>
                </Link>
              </Menu.Item>
              <Menu.Item key='voting/votes'>
                <Link to='/voting/votes'>
                  <span className='pl-3 text-gray-200 text-sm'>Votes</span>
                </Link>
              </Menu.Item>
              <Menu.Item key='voting/voters-group'>
                <Link to='/voting/voters-group'>
                  <span className='pl-3 text-gray-200 text-sm'>
                    Voters Group
                  </span>
                </Link>
              </Menu.Item>
            </SubMenu>
          )}
        </MenuItemGroup> */}

        <MenuItemGroup key='employee-services' className='gx-menu-group'>
          {Helpers.authorizeMe(authorizations[8], 'view', 111) && (
            <SubMenu
              key='company'
              title={
                <div className='flex my-3 text-white items-center'>
                  <div className='text-xl md:text-2xl'>
                    <FaBuilding />
                  </div>
                  <div className='px-4 -my-3'>Company</div>
                </div>
              }
            >
              {Helpers.authorizeMe(authorizations[8], 'view', 102) && (
                <Menu.Item key='company/announcements'>
                  <Link to='/company/announcements'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Announcements
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 103) && (
                <Menu.Item key='company/validations'>
                  <Link to='/company/validations'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Company Validations
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 104) && (
                <Menu.Item key='company/alumni'>
                  <Link to='/company/alumni'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Alumni Opt-in Network
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 105) && (
                <Menu.Item key='company/departments'>
                  <Link to='/company/departments'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Departments
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 106) && (
                <Menu.Item key='company/usergroups'>
                  <Link to='/company/usergroups'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      User Groups
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 107) && (
                <Menu.Item key='company/documents'>
                  <Link to='/company/documents'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Documents
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 108) && (
                <Menu.Item key='company/events'>
                  <Link to='/company/events'>
                    <span className='pl-3 text-gray-200 text-sm'>Surveys</span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 109) && (
                <Menu.Item key='company/company-holidays'>
                  <Link to='/company/company-holidays'>
                    <span className='pl-3 text-gray-200 text-sm'>Holidays</span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 17) && (
                <Menu.Item key='company/job-roles'>
                  <Link to='/company/job-roles'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Job Roles
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 110) && (
                <Menu.Item key='company/letters'>
                  <Link to='/company/letters'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Templates
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 112) && (
                <Menu.Item key='company/branches'>
                  <Link to='/company/branches'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Locations
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 113) && (
                <Menu.Item key='company/notifications'>
                  <Link to='/company/notifications'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Notifications
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 114) && (
                <Menu.Item key='company/pay-structures' className='hidden'>
                  <Link to='/company/pay-structures'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Pay Structures
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 115) && (
                <Menu.Item key='company/rates'>
                  <Link to='/company/rates'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Exchange Rates
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {/* <Menu.Item key='company/guides'>
                    <a
                        download
                        href='/User Guide - Home and Company Tabs_Employee Management Module.pdf'
                    >
                        <span className='pl-7 text-gray-200 text-sm'>
                        Company Guide
                        </span>
                    </a>
                    </Menu.Item> */}
            </SubMenu>
          )}

          {Helpers.authorizeMe(authorizations[8], 'view', 117) && (
            <SubMenu
              key='onboarding'
              title={
                <div className='flex my-3 text-white items-center'>
                  <div className='text-xl md:text-2xl'>
                    <FaUserPlus />
                  </div>
                  <div className='px-4 -my-3'>Onboarding</div>
                </div>
              }
            >
              {Helpers.authorizeMe(authorizations[8], 'view', 116) && (
                <Menu.Item key='company/candidates'>
                  <Link to='/company/candidates'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Candidates
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 20) && (
                <Menu.Item key='company/onboarding-tasks'>
                  <Link to='/company/onboarding-tasks'>
                    <span className='pl-3 text-gray-200 text-sm'>Tasks</span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 40) && (
                <Menu.Item key='company/onboarding-feedback'>
                  <Link to='/company/onboarding-feedback'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Feedback
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 107) && (
                <Menu.Item key='company/document-types'>
                  <Link to='/company/document-types'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Document Types
                    </span>
                  </Link>
                </Menu.Item>
              )}
            </SubMenu>
          )}

          {Helpers.authorizeMe(authorizations[8], 'view', 118) && (
            <SubMenu
              key='employee'
              title={
                <div className='flex my-3 text-white items-center'>
                  <div className='text-xl md:text-2xl'>
                    <FaUsers />
                  </div>
                  <div className='px-4 -my-3'>Employees</div>
                </div>
              }
            >
              {/* <Menu.Item key='employee/appraisal-documents'>
                    <Link to='/employee/appraisal-documents'>
                        <span className='pl-3 text-gray-200 text-sm'>
                        Appraisal Documents
                        </span>
                    </Link>
                    </Menu.Item> */}
              {/*
                        <Menu.Item key="employee/attendance">
                            <Link to="/employee/attendance">
                                <span className="pl-7 text-gray-200 text-sm">Attendance</span>
                            </Link>
                        </Menu.Item>
                    */}
              {Helpers.authorizeMe(authorizations[8], 'view', 119) && (
                <Menu.Item key='employee/document-status'>
                  <Link to='/employee/document-status'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Document Status
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 21) && (
                <Menu.Item key='employee/employee-center'>
                  <Link to='/employee/employee-center'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Employee Center
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 76) && (
                <Menu.Item key='employee/employee-files'>
                  <Link to='/employee/employee-files'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Employee Files
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 75) && (
                <Menu.Item key='employee/employee-rates'>
                  <Link to='/employee/employee-rates'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Employee Rates
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 22) && (
                <Menu.Item key='employee/employee-variations'>
                  <Link to='/employee/employee-variations'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Employee Variations
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 72) && (
                <Menu.Item key='employee/employee-verifications'>
                  <Link to='/employee/employee-verifications'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Employee Verifications
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 121) && (
                <Menu.Item key='employee/profile-verifications'>
                  <Link to='/employee/profile-verifications'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Profile Update
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 71) && (
                <Menu.Item key='employee/transition'>
                  <Link to='/employee/transition'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Transition{' '}
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 73) && (
                <Menu.Item key='employee/exits'>
                  <Link to='/employee/exits'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Offboarding
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 74) && (
                <Menu.Item key='employee/salary-advances'>
                  <Link to='/employee/salary-advances'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Salary Advances
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 122) && (
                <Menu.Item key='employee/supervisors'>
                  <Link to='/employee/supervisors'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Supervisors
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 122) && (
                <Menu.Item key='employee/training-schedules'>
                  <Link to='/employee/training-schedules'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Trainings
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {/* <Menu.Item key='employee/guides'>
                    <a
                        download
                        href='/User Guide - Employee Tab_Employee Management Module.pdf'
                    >
                        <span className='pl-7 text-gray-200 text-sm'>
                        Employee Guide
                        </span>
                    </a>
                    </Menu.Item> */}
            </SubMenu>
          )}

          {Helpers.authorizeMe(authorizations[8], 'view', 124) && (
            <SubMenu
              key='issues'
              title={
                <div className='flex my-3 text-white items-center'>
                  <div className='text-xl md:text-2xl'>
                    <MdReport />
                  </div>
                  <div className='px-4 -my-3'>Issues</div>
                </div>
              }
            >
              {Helpers.authorizeMe(authorizations[8], 'view', 78) && (
                <Menu.Item key='issues/blacklist'>
                  <Link to='/issues/blacklist'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Blacklist
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 79) && (
                <Menu.Item key='issues/cases'>
                  <Link to='/issues/cases'>
                    <span className='pl-3 text-gray-200 text-sm'>Cases</span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 80) && (
                <Menu.Item key='issues/confidential-notes'>
                  <Link to='/issues/confidential-notes'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Confidential Notes
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 81) && (
                <Menu.Item key='issues/employee-queries'>
                  <Link to='/issues/employee-queries'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Employee Queries
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {/* <Menu.Item key='issues/guides'>
                    <a
                        download
                        href='/User Guide - Issues Tab_Employee Management Module.pdf'
                    >
                        <span className='pl-7 text-gray-200 text-sm'>Issues Guide</span>
                    </a>
                    </Menu.Item> */}
            </SubMenu>
          )}

          {Helpers.authorizeMe(authorizations[8], 'view', 125) && (
            <SubMenu
              key='leave-tracker'
              title={
                <div className='flex my-3 text-white items-center'>
                  <div className='text-xl md:text-2xl'>
                    <FaBriefcase />
                  </div>
                  <div className='px-4 -my-3'>Leave</div>
                </div>
              }
            >
              {Helpers.authorizeMe(authorizations[8], 'view', 82) && (
                <Menu.Item key='leave-tracker/leave'>
                  <Link to='/leave-tracker/leave'>
                    <span className='pl-3 text-gray-200 text-sm'>Policy</span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 127) && (
                <Menu.Item key='leave-tracker/leave-insights'>
                  <Link to='/leave-tracker/leave-insights'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Leave Insights
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 84) && (
                <Menu.Item key='leave-tracker/leave-applications'>
                  <Link to='/leave-tracker/leave-applications'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      All Applications
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 83) && (
                <Menu.Item key='leave-tracker/leave-applications-others'>
                  <Link to='/leave-tracker/leave-applications-others'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Department Applications
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 85) && (
                <Menu.Item key='leave-tracker/leave-resumption'>
                  <Link to='/leave-tracker/leave-resumption'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Leave Resumption
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {/* <Menu.Item key='leave-tracker/guides'>
                    <a
                        download
                        href='/User Guide - Leave Tracker Tab_Employee Management Module.pdf'
                    >
                        <span className='pl-7 text-gray-200 text-sm'>Leave Guide</span>
                    </a>
                    </Menu.Item> */}
            </SubMenu>
          )}

          {Helpers.authorizeMe(authorizations[8], 'view', 53) && (
            <SubMenu
              key='attendance'
              title={
                <div className='flex my-3 text-white items-center'>
                  <div className='text-xl md:text-2xl'>
                    <FaClock />
                  </div>
                  <div className='px-4 -my-3'>Attendance</div>
                </div>
              }
            >
              {Helpers.authorizeMe(authorizations[8], 'view', 86) && (
                <Menu.Item key='attendance/reports'>
                  <Link to='/attendance/reports'>
                    <span className='pl-3 text-gray-200 text-sm'>Report</span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 120) && (
                <Menu.Item key='employee/location_tracker'>
                  <Link to='/employee/location_tracker'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Employee Location Tracker
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {Helpers.authorizeMe(authorizations[8], 'view', 87) && (
                <Menu.Item key='attendance/daily_attendance_status'>
                  <Link to='/attendance/daily_attendance_status'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Attendance Insights
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 88) && (
                <Menu.Item key='attendance/regularization'>
                  <Link to='/attendance/regularization'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Regularization
                    </span>
                  </Link>
                </Menu.Item>
              )}
            </SubMenu>
          )}
          {Helpers.authorizeMe(authorizations[8], 'view', 89) && (
            <SubMenu
              key='supervisor'
              title={
                <div className='flex my-3 text-white items-center'>
                  <div className='text-xl md:text-2xl'>
                    <FaClipboardCheck />
                  </div>
                  <div className='px-4 -my-3'>Validation</div>
                </div>
              }
            >
              {Helpers.authorizeMe(authorizations[8], 'view', 89) && (
                <Menu.Item key='supervisor/employeevalidation'>
                  <Link to='/supervisor/employeevalidation'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Employee Validation
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 90) && (
                <Menu.Item key='employeevalidation/reports'>
                  <Link to='/employeevalidation/reports'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Validation Reports
                    </span>
                  </Link>
                </Menu.Item>
              )}
            </SubMenu>
          )}

          {Helpers.authorizeMe(authorizations[8], 'view', 34) && (
            <SubMenu
              key='payroll'
              title={
                <div className='flex my-3 text-white items-center'>
                  <div className='text-xl md:text-2xl'>
                    <FaBook />
                  </div>
                  <div className='px-4 -my-3'>Payroll</div>
                </div>
              }
            >
              {Helpers.authorizeMe(authorizations[8], 'view', 34) && (
                <Menu.Item key='payroll/payroll-center'>
                  <Link to='/payroll/payroll-center'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Payroll Center
                    </span>
                  </Link>
                </Menu.Item>
              )}
            </SubMenu>
          )}

          {Helpers.authorizeMe(authorizations[8], 'view', 126) && (
            <SubMenu
              key='performance'
              title={
                <div className='flex my-3 text-white items-center'>
                  <div className='text-xl md:text-2xl'>
                    <FaBookReader />
                  </div>
                  <div className='px-4 -my-3'>Performance Management</div>
                </div>
              }
            >
              {Helpers.authorizeMe(authorizations[8], 'view', 126) && (
                <Menu.Item key='performance/performance-center'>
                  <Link to='/performance/performance-center'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Performance Center
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 91) && (
                <Menu.Item key='performance/appraisals'>
                  <Link to='/performance/appraisals'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Appraisals
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 92) && (
                <Menu.Item key='performance/goals'>
                  <Link to='/performance/goals'>
                    <span className='pl-3 text-gray-200 text-sm'>Goals</span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 93) && (
                <Menu.Item key='performance/okrs'>
                  <Link to='/performance/okrs'>
                    <span className='pl-3 text-gray-200 text-sm'>OKRS</span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 94) && (
                <Menu.Item key='performance/deliverables'>
                  <Link to='/performance/deliverables'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Deliverables
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 95) && (
                <Menu.Item key='performance/settings'>
                  <Link to='/performance/settings'>
                    <span className='pl-3 text-gray-200 text-sm'>Settings</span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 96) && (
                <Menu.Item key='performance/targets'>
                  <Link to='/performance/targets'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Company Targets
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 97) && (
                <Menu.Item key='performance/projects'>
                  <Link to='/performance/projects'>
                    <span className='pl-3 text-gray-200 text-sm'>Projects</span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 98) && (
                <Menu.Item key='performance/employees'>
                  <Link to='/performance/employees'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Employees
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 99) && (
                <Menu.Item key='performance/competencies'>
                  <Link to='/performance/competencies'>
                    <span className='pl-3 text-gray-200 text-sm'>
                      Competencies
                    </span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 100) && (
                <Menu.Item key='performance/rewards'>
                  <Link to='/performance/rewards'>
                    <span className='pl-3 text-gray-200 text-sm'>Rewards</span>
                  </Link>
                </Menu.Item>
              )}
              {Helpers.authorizeMe(authorizations[8], 'view', 101) && (
                <Menu.Item key='performance/reports'>
                  <Link to='/performance/reports'>
                    <span className='pl-3 text-gray-200 text-sm'>Reports</span>
                  </Link>
                </Menu.Item>
              )}
            </SubMenu>
          )}

          {Helpers.authorizeMe(authorizations[8], 'view', 130) && (
            <SubMenu
                key='approvals'
                title={
                    <div className='flex my-3 text-white items-center'>
                        <div className='text-xl md:text-2xl'>
                            <FaCheckDouble />
                        </div>
                        <div className='px-4 -my-3'>Approvals</div>
                    </div>
                }
            >
                {Helpers.authorizeMe(authorizations[8], 'view', 130) && (
                    <Menu.Item key='company/employee-approval'>
                        <Link to='/company/employee-approval'>
                            <span className='pl-3 text-gray-200 text-sm'>
                                Employee Approvals
                            </span>
                        </Link>
                    </Menu.Item>
                )}
            </SubMenu>
          )}
        </MenuItemGroup>
      </Menu>
    </>
  )
}

SidebarContent.propTypes = {}
export default SidebarContent
